<div class="d-flex justify-content-center" style="flex: 1">

    <ng-container *ngFor="let item of items">
        <div class="col-sm-12 col-md-4" (click)="select($event, item)">
            <div class="product-grid-item card"
                 [ngClass]="{'selected': isSelected(item)}">
                <div class="product-grid-item-top">
                </div>
                <div class="product-grid-item-content">

                    <div class="product-image">
                        <div class="product-image-helper"></div>
                        <img src="{{getImgUrl(item.code)}}" alt="Article picture" />
                    </div>
                    <div class="product-name">{{item.title}}</div>
                    <div class="product-description">{{item.description}}</div>

                    <ng-container>


                    </ng-container>


                    <div class="product-description">{{item.deliveryDate | momentFormat:'L'}}</div>
                </div>
                <div class="product-grid-item-bottom">
                    <span class="product-price">{{item.price | currency:item.currency:'symbol-narrow':'.2-2'}}</span>
                </div>
            </div>
        </div>
    </ng-container>
</div>
